import { useState, useCallback } from "react";

type StateHistory<T> = {
  past: T[]; // 存储过去状态的数组（撤销栈）
  present: T; // 当前状态
  future: T[]; // 存储未来状态的数组（重做栈）
};

export default function useUndoRedo<T>(initialState: T, maxHistory = 10) {
  const [state, setState] = useState<StateHistory<T>>({
    past: [],
    present: initialState,
    future: [],
  });

  const canUndo = state.past.length > 0;
  const canRedo = state.future.length > 0;

  const undo = useCallback(() => {
    console.log("undo----------", state);

    if (!canUndo) return;

    const previous = state.past[state.past.length - 1];
    const newPast = state.past.slice(0, -1);

    setState({
      past: newPast,
      present: previous,
      future: [state.present, ...state.future],
    });
  }, [canUndo, state]);

  const redo = useCallback(() => {
    if (!canRedo) return;

    const next = state.future[0];
    const newFuture = state.future.slice(1);

    setState({
      past: [...state.past, state.present],
      present: next,
      future: newFuture,
    });
  }, [canRedo, state]);

  const set = useCallback(
    (newState: T) => {
      console.log("set ---------------", newState);

      setState((prev) => {
        const newPast = [...prev.past, prev.present].slice(-maxHistory);
        return {
          past: newPast,
          present: newState,
          future: [],
        };
      });
    },
    [maxHistory]
  );

  const reset = useCallback((newState: T) => {
    setState({
      past: [],
      present: newState,
      future: [],
    });
  }, []);

  return {
    state: state.present,
    setState: set,
    undo,
    redo,
    canUndo,
    canRedo,
    reset,
    history: state,
  };
}
